<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">授权对象：</span>
        </div>
        <div>
          <div style="display: flex;justify-content: flex-start;margin: 0 0 10px;align-items: center;" v-if="enterpriseList.length > 0">
            <div style="color: #666666;">授权企业：</div>
            <el-tag
              v-for="(tag, index) in enterpriseList"
              style="margin-right: 10px;"
              :key="tag.enterpriseName"
              closable
              @close="enterpriseClose(index)"
              :type="''">
              {{tag.enterpriseName}}
            </el-tag>
          </div>
          <div style="display: flex;justify-content: flex-start;margin: 0 0 10px;align-items: center;" v-if="personList.length > 0">
            <div style="color: #666666;">授权人员：</div>
            <el-tag
              v-for="(tag, index) in personList"
              style="margin-right: 10px;"
              :key="tag.name"
              closable
              @close="personClose(index)"
              :type="''">
              {{tag.name}}
            </el-tag>
          </div>
          <div><i class="el-icon-circle-plus-outline" style="font-size: 20px;color: #00a0e6;cursor: pointer;" @click="showTip = true"></i></div>
        </div>
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">授权对象：</span>-->
        <!--</div>-->
        <!--<el-select v-model="personCode"-->
                   <!--filterable-->
                   <!--remote-->
                   <!--reserve-keyword-->
                   <!--size="small" style="width: 280px"-->
                   <!--:remote-method="remoteMethod"-->
                   <!--placeholder="请输入关键词查询">-->
          <!--<el-option v-for="item in responsiblePersonList" :key="item._value"-->
                     <!--:label="item._label" :value="item._value">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">楼栋：</span>
        </div>
        <el-select v-model="buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in allBuildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电梯：</span>
        </div>
        <el-select v-model="liftDeviceCode" multiple size="small" style="width: 280px" @change="liftDeviceCodeChange">
          <el-option v-for="item in liftDeviceList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line" style="display: flex;justify-content: flex-start;align-items: top;">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">授权楼层：</span>
        </div>
        <div style="display: inline-block;width: 500px;">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedLevels" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="level in levelList" :label="level" :key="level">{{level}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>


    <el-dialog title="添加授权" :visible.sync="showTip" width="792px">
      <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
        <el-tab-pane label="住户授权" name="first" class="el_tab_item">
          <auth-tree ref="red" class="filter-tree" :update="treeUpdate"  />
        </el-tab-pane>
        <el-tab-pane label="人员授权" name="second">
          <!--远程搜索-->
          <el-input placeholder="姓名/手机号/所属住户" v-model="requestBody.searchKey" class="input-with-select" @keyup.13.native="getBasicPersonPage" size="small" style="margin-bottom: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="getBasicPersonPage" size="small" />
          </el-input>
          <el-table
            ref="authPersonTable"
            :data="authPersonData"
            @select="selectPerson"
            tooltip-effect="dark"
            height="2rem"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="75px">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号">
            </el-table-column>
            <el-table-column
              prop="enterpriseName"
              label="所属住户">
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination background layout="total, prev, pager, next, jumper"
                           @current-change="handleCurrentChange" :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAthority" size="small">取 消</el-button>
        <el-button type="primary" @click="addAthority" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/LadderControl'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import AuthTree from '../../../components/common/auth-tree'

  export default {
    components: {
      AuthTree,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'authorize-add',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧梯控',
            name: 'ladder-device'
          }, {
            value: '授权乘梯',
          }]
        },
        mainTitle: '添加授权',
        subheading: '',
        checkAll: false,
        checkedLevels: [],
        levelList: [],
        isIndeterminate: true,

        responsiblePersonList: [],
        chooseLiftDeviceList: [],
        liftDeviceList: [],
        liftDeviceName: '',
        liftDeviceCode: '',
        levels: '',
        gateWayDeviceName: '',
        gateWayDeviceCode: '',
        personName: '',
        personCode: '',
        enterpriseName: '',
        enterpriseCode: '',
        cardNumberEntity: '',

        buildingCode: '',
        allBuildingList: [],

        allEnterpriseList: [],
        enterpriseList: [],
        personList: [],
        wantPersonList: [],
        pageSelectPerson: [],
        requestBody: {
          pageNum: 1,
          pageSize: 10,
          searchKey: ''
        },
        total: 0,
        activeName2: 'first',
        authPersonData: [],
        showTip: false,
        props1: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
        },
        treeUpdate: {
          render: () => {
            return api.getEnterpriseInfoList()
              .then(list => {
                list.forEach(tree => {
                  tree._label = tree.enterpriseName
                })
                return list
              })
          }
        },
        personAuth: false,
        departmentAuth: true,
        adsStr: ''
      }
    },
    created () {
      this.getBuildingList()
      // this.getLiftDeviceList()
      this.getResponsiblePersonList()
      this.getBasicPersonPage()
      this.getEnterpriseInfoList()
    },
    methods: {
      // 获取所有楼栋列表
      getBuildingList () {
        api.getBuildingList()
          .then(list => {
            this.allBuildingList = list
          })
          .catch(errorHandler('获取楼栋失败'))
      },
      // 获取所有住户列表
      getEnterpriseInfoList () {
        api.getEnterpriseInfoList()
          .then(list => {
            this.allEnterpriseList = list
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 获取电梯列表
      getLiftDeviceList (req) {
        api.getLiftDeviceList(req)
          .then(data => {
            this.liftDeviceList = data
          })
          .catch(errorHandler('获取电梯列表失败'))
      },

      getResponsiblePersonList (searchKey) {
        api.getPersonList({searchKey: searchKey || ''})
          .then(list => {
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
            })
            this.responsiblePersonList = list
          })
      },
      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },
      add () {
        if (!this.liftDeviceCode) {
          nError('请选择电梯')
          return false
        }
        if (this.enterpriseList.length === 0 && this.personList.length === 0) {
          nError('请选择授权对象')
          return false
        }
        let obj = {
          liftDeviceList: this.chooseLiftDeviceList,

          levels: this.checkedLevels.join(','),

          // personName: this.personName,
          // personCode: this.personCode,
          cardNumberEntity: this.cardNumberEntity,
          // enterpriseName: this.enterpriseName,
          // enterpriseCode: this.enterpriseCode
          enterpriseList: this.enterpriseList,
          personList: this.personList,
        }
        api.addLiftAuthority(obj)
          .then(() => {
            nSuccess('授权成功')
            this.strategyCenter()
          })
          .catch(errorHandler('授权失败'))
      },
      strategyCenter () {
        this.$router.go(-1)
        // this.$router.push({
        //   path: '/access-control/device/center'
        // })
      },

      handleCheckAllChange(val) {
        this.checkedLevels = val ? this.levelList : []
        this.isIndeterminate = false
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.levelList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.levelList.length;
      },

      enterpriseClose (index) {
        this.enterpriseList.splice(index, 1)
      },
      personClose (index) {
        this.personList.splice(index, 1)
      },

      handleClick (tab) {
        if (tab.index === '0') {
          this.personAuth = false
          this.departmentAuth = true
        } else {
          this.personAuth = true
          this.departmentAuth = false
        }
      },
      getBasicPersonPage () {
        api.getBasicPersonPage(this.requestBody)
          .then((data) => {
            this.total = data.total
            this.authPersonData = data.list

          })
      },
      // 选择人员
      selectPerson (selection, row) {
        selection.map(select => {
          let hasPerson = false
          this.wantPersonList.map(want => {
            if (want.code === select.code) {
              hasPerson = true
            }
          })
          if (!hasPerson) {
            this.wantPersonList.push(select)
          }
        })
      },
      cancelAthority () {
        this.showTip = false
        this.$refs.red._self.$refs.tree.setCheckedNodes([])
      },
      addAthority () {
        let enterpriseCodeStr = window.sessionStorage.getItem('changeAuthDep')
        let enterpriseList = this.enterpriseList
        if (enterpriseCodeStr) {
          let oldCodeArr = []
          enterpriseList.map(old => {
            oldCodeArr.push(old.code)
          })
          this.allEnterpriseList.map(enterprise => {
            if (enterpriseCodeStr.indexOf(enterprise.code) !== -1 && oldCodeArr.indexOf(enterprise.code) === -1) {
              enterpriseList.push(enterprise)
            }
          })
        }
        this.enterpriseList = enterpriseList
        this.personList = this.wantPersonList

        this.showTip = false
        this.wantPersonList = []
        window.sessionStorage.setItem('changeAuthDep', '')

      },
      handleSelectionChange (val) {
        let adsArr = []
        val.map(v => {
          adsArr.push(v.code)
        })
        this.adsStr = adsArr.join(',')
      },
      handleCurrentChange (val) {
        this.requestBody.pageNum = val
        this.getBasicPersonPage()
      },

      liftDeviceCodeChange (val) {
        let chooseLiftDeviceList = []
        let minStartLevel = null
        let maxEndLevel = null
        this.liftDeviceList.map(v => {
          if (val.indexOf(v.code) !== -1) {
            chooseLiftDeviceList.push(v)
            this.gateWayDeviceCode = v.relateGatewayCode
            this.gateWayDeviceName = v.relateGatewayName
            this.liftDeviceName = v.name
            if (v.startLevel > v.endLevel) {
              let tem = v.startLevel
              v.startLevel = v.endLevel
              v.endLevel = tem
            }
            if (!minStartLevel) {
              minStartLevel = v.startLevel
            } else {
              if (v.startLevel < minStartLevel) {
                minStartLevel = v.startLevel
              }
            }
            if (!maxEndLevel) {
              maxEndLevel = v.endLevel
            } else {
              if (v.endLevel > maxEndLevel) {
                maxEndLevel = v.endLevel
              }
            }
          }
        })
        this.checkedLevels = []
        let levelList = []
        if (minStartLevel && maxEndLevel) {
          for (let i = minStartLevel; i < maxEndLevel + 1; i++) {
            if (i !== 0) {
              levelList.push(i.toString())
            }
          }
        }
        this.levelList = levelList
        this.chooseLiftDeviceList = chooseLiftDeviceList
      }
    },
    watch: {
      buildingCode(val) {
        let req = {
          buildingCode: val
        }
        this.getLiftDeviceList(req)
      },
      personCode (val) {
        this.responsiblePersonList.map(v => {
          if (v.code === this.personCode) {
            this.personName = v.name
            this.enterpriseName = v.enterpriseName
            this.enterpriseCode = v.enterpriseCode
            this.cardNumberEntity = v.cardNumberEntity
          }
        })
      },

    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .form-line {
    .el-checkbox {
      margin-left: 0!important;
      margin-right: 30px;
    }
    .el-checkbox__label {
      width: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/Authorize/AuthorizeAdd.vue